export default __webpack_public_path__ + "static/media/TestComplete-Logo.f124b967.svg";